import React from 'react'
import Navbar from './Navbar'
import TopRightNav from './TopRightNav';
import { useIntl, Link } from "gatsby-plugin-intl"

export default function Header() {
    const intl = useIntl();
    return (
        <header className="header" id="header">
            <Navbar />
            <div className="header--banner">
                <div className="menuReveal">
                    {/* <Link to="/" id="menu-toggle" aria-label="Open the menu" onClick={console.log('Clicked !')}>☰ Menu</Link> */}
                    <a
            href="#topNav"
            id="menu-toggle" aria-label={intl.formatMessage({ id: "accessibility0" })}
            aria-expanded="false"
            onClick={() => {
                const topNav = document.getElementById("topNav");
                const menuToggle = document.getElementById("menu-toggle");
        
                const arrowMenu = document.getElementsByClassName('menuReveal__arrow')[0];
                if(arrowMenu.classList[1]){
                    arrowMenu.classList.remove('menuReveal__arrow--rotated');
                } else {
                    arrowMenu.classList.add('menuReveal__arrow--rotated');
                }
                
                if(topNav.style.display === "block"){
                    topNav.style.display = "none";
                    menuToggle.setAttribute('aria-expanded', 'false')
                } else {
                    topNav.style.display = "block";
                    menuToggle.setAttribute('aria-expanded', 'true')
                }   
            }}
          >
            <span className="menuReveal__arrow">
            <img src="/chevron.svg" alt="" style={{ height: '0.7rem' }} />
            </span> Menu
          </a>
                </div>
                <div className="siteTitle">
                    <Link to="/">
                        <img src="/TGM_logo.svg" alt={intl.formatMessage({ id: "contact5" })} style={{ maxHeight: '100%' }} />
                    </Link>
                </div>
                <TopRightNav />
            </div>
        </header>
    )
}
